import ScopeOverview from './ScopeOverview.container';

export default ScopeOverview;